import React from 'react';
import TabPanes from '@/components/tabs/TabPanes';
import { userTabs } from '../constants';
import UsersGroupsTable from '../groups/containers/UsersGroupsTable';

const tabs = {
  [userTabs.GROUPS.name]: { Content: UsersGroupsTable },
};

const UserPanelTabs = ({ category, code }) => {
  const onRender = (name) => {
    const { Content } = tabs[name];
    return { content: (<Content code={code} category={category} />) };
  };

  return (
    <TabPanes
      activeIndex={0}
      className="aridhia-user-panel-tabs"
      entity="user"
      indexes={[0]}
      onRender={onRender}
      pointing
      secondary
      tabs={userTabs}
    />
  );
};

export default UserPanelTabs;
